<template>
    <button v-if="canOpen" v-bind="$attrs" type="button" class="block cursor-zoom-in overflow-hidden focus:outline-none focus-visible:ring-2 focus-visible:ring-nomad-accent"
        :aria-label="'View ' + title + ' full screen'" @click="open">
        <img :src="src" :alt="title" class="h-full w-full object-cover" />
    </button>
    <!-- A placeholder is only something to look at, so it doesn't open -->
    <div v-else v-bind="$attrs" class="overflow-hidden">
        <slot>
            <img v-if="src" :src="src" :alt="title" class="h-full w-full object-cover" />
            <span v-else class="flex h-full w-full items-center justify-center bg-nomad-800 text-5xl text-nomad-500" aria-hidden="true"><span class="icon-music"></span></span>
        </slot>
    </div>

    <!-- A modal dialog is in the browser's top layer, above any z-index: the player, menus and ads -->
    <dialog ref="dialog" class="artwork-viewer" @close="onClose" @click.self="close" @keydown.stop>
        <div v-if="isOpen" class="flex h-full w-full flex-col" @click.self="close">
            <div class="flex shrink-0 items-start justify-between gap-4 p-4" @click.self="close">
                <div class="min-w-0">
                    <p class="truncate text-lg font-semibold text-white">{{ title }}</p>
                    <p v-if="subtitle" class="truncate text-sm text-nomad-300">{{ subtitle }}</p>
                </div>
                <button type="button" class="nl-btn-icon shrink-0 text-white" aria-label="Close" autofocus @click="close">
                    <span class="icon-x" aria-hidden="true"></span>
                </button>
            </div>
            <div class="flex min-h-0 flex-1 items-center justify-center px-4 pb-4" @click.self="close">
                <img :src="src" :alt="title" class="max-h-full max-w-full object-contain" />
            </div>
        </div>
    </dialog>
</template>
<script>
import { nextTick } from "vue";

export default {
    name: "ArtworkImage",
    // Sizes and rounding belong on the picture, not the dialog
    inheritAttrs: false,
    props: {
        src: String,
        title: String,
        subtitle: String,
    },
    data() {
        return { isOpen: false };
    },
    computed: {
        canOpen() {
            // Artists without a picture get this image from the server, not an empty value
            return !!this.src && !this.src.includes("/assets/images/no-artist");
        },
    },
    beforeUnmount() {
        if (this.isOpen) this.unlockScroll();
    },
    methods: {
        async open() {
            this.isOpen = true;
            await nextTick();
            this.$refs.dialog.showModal();
            document.documentElement.style.overflow = "hidden";
        },
        close() {
            this.$refs.dialog.close();
        },
        onClose() {
            this.isOpen = false;
            this.unlockScroll();
        },
        unlockScroll() {
            document.documentElement.style.overflow = "";
        },
    },
};
</script>
<style scoped>
.artwork-viewer {
    width: 100vw;
    height: 100dvh;
    max-width: none;
    max-height: none;
    margin: 0;
    padding: 0;
    border: 0;
    background: #000;
}
</style>
